import { PasswordInput } from '@moda/om';
import { validateFormValue } from '@moda/portal-stanchions';
import React, { useMemo, useState } from 'react';
import { usePasswordValidation } from '../../../../hooks/usePasswordValidation';

interface Props {
  className?: string;
  error?: string | boolean | undefined;
}

export const RegisterPasswordInput: React.FC<Props> = ({ className, error }) => {
  const { passwordValidation } = usePasswordValidation();

  const [password, setPassword] = useState('');

  const validationResult = useMemo(() => {
    if (password.length === 0) return null;

    return validateFormValue(password, passwordValidation);
  }, [password, passwordValidation]);

  return (
    <PasswordInput
      className={className}
      error={validationResult?.message || error}
      value={password}
      onChange={setPassword}
      id="registerPassword"
      data-testid="registerPassword"
      placeholder="Password"
    />
  );
};
